import { useContext } from 'react';
import { ThemeContext } from '../context/theme.context';

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

// Convenience hook for accessing just the design tokens
export function useDesignTokens() {
  const { tokens } = useTheme();
  return tokens;
}
